import app from 'flarum/forum/app';
import Page from 'flarum/forum/components/Page';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import icon from 'flarum/common/helpers/icon';

export default class ApplicationStatusPage extends Page {
    oninit(vnode) {
        super.oninit(vnode);

        app.history.push('application.status', icon('fas fa-th'));

        app.setTitle(app.translator.trans('xtreh-phoenix.forum.applications.status.label'));
        app.setTitleCount(0);

        this.applications = [];
        this.isLoading = true;

        app.request({
            method: 'POST',
            url: '/applications/status/payload'
        }).then((response) => {
            this.isLoading = false;
            this.applications = response.applications;
            m.redraw();
        });
    }

    view() {
        const applications = this.applications;

        return (
            <div className='ApplicationStatusPage'>
                <div className='ApplicationStatus'>
                    <div className='ApplicationStatus-header'>
                        <h4 className='App-titleControl App-titleControl--text'> { app.translator.trans('xtreh-phoenix.forum.applications.status.label') }</h4>
                    </div>
                    <div className='ApplicationStatus-content'>
                        {
                            this.isLoading ? <LoadingIndicator /> : applications.map((application) =>
                                <div className='ApplicationStatus-item'>
                                    <span className='ApplicationStatus-name'>{application.name}</span>
                                    <span className='ApplicationStatus-separator'/>
                                    <span className='ApplicationStatus-status' data={application.status.application}>{application.status.application}</span>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }

    content() {}
}
